import { PhotoSize } from '@alltrails/shared/types/photos';
import { getPhotoUrl } from '@alltrails/shared/utils/requests/photoRequests';

export const apiKey = '3p0t5s6b5g4g0e8k3c1j3w7y5c3m4t8i';

// returns an array of photos that can be processed by the lightbox
const urlReformatPhotos = photos => {
  let imageHash;

  return photos.map(photo => {
    const { id, photo_hash, photoHash } = photo;
    imageHash = photo_hash || photoHash; // function is flexible whether photohash is coming from the photo class

    // TODO: Add support for fallback when direct CDN link doesn't work right
    const url =
      id && imageHash
        ? getPhotoUrl({ id, photoHash: imageHash }, PhotoSize.ExtraLarge)
        : `/api/alltrails/photos/${id}/image?size=extra_large&api_key=${apiKey}`;
    return { id, url };
  });
};

// returns only what the lightbox needs
const formatImagesForLightbox = photos => {
  return photos.map(photo => {
    const { id, url } = photo;
    return { id, url };
  });
};

export { urlReformatPhotos, formatImagesForLightbox };
